import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import { getInvoicesByDocRef } from "../../../../services/finance/invoice";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import Illustration from "../../../../partials/content/Illustration";
import { Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import CustomPrintOutInvoice from "../../../../partials/content/CustomPrintOutInvoice";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const DocRefInvoices = ({ history, docRef = "", docID = "" }) => {
  const { reload } = useGlobalData();
  const [invoices, setInvoices] = useState([]);
  const [invoice, setInvoice] = useState({});
  const [openInvoicePrint, setOpenInvoicePrint] = useState(false);
  const [fullyPaids, setFullyPaids] = useState(0);
  const [partiallyPaids, setPartiallyPaids] = useState(0);
  const [unpaids, setUnpaids] = useState(0);
  const paymentColumn = [
    {
      header: "A/R Payment ID",
      field: "incomingPaymentCode",
      body: null,
      sortable: true,
    },
    {
      header: "Payment Date",
      field: "paymentDate",
      body: (rowData) => formatDate(rowData.paymentDate),
      sortable: true,
    },
    {
      header: "Cash Account",
      field: "glAccount.accountName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis
            text={rowData.glAccount.accountName}
            maxLine="1"
          />
        </React.Fragment>
      ),
      sortable: true,
    },
    {
      header: "Currency",
      field: "currency.currencyCode",
      body: null,
      sortable: true,
      hidden: true,
    },
    {
      header: "Payment Amount",
      field: "paymentAmount",
      body: (rowData) => (
        <NumberFormat
          value={rowData.paymentAmount}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currency.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
    },
  ];
  useEffect(() => {
    getInvoicesData();
  }, [docRef, docID, reload]);

  async function getInvoicesData() {
    const response = await getInvoicesByDocRef(docRef, docID);
    const { data } = response.data;
    setInvoices(data.invoices);
    const fullyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 3
    );
    const partiallyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 2
    );
    const unpaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 1
    );
    setFullyPaids(fullyPaids.length);
    setPartiallyPaids(partiallyPaids.length);
    setUnpaids(unpaids.length);
  }
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-success">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-check-circle kt-font-success" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">FULLY PAID</div>
                </div>
                <Badge variant="success">{fullyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">
                    PARTIALLY PAID
                  </div>
                </div>
                <Badge variant="warning">{partiallyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">UNPAID</div>
                </div>
                <Badge variant="danger">{unpaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {invoices.length ? (
        <React.Fragment>
          <CustomDataTable
            data={invoices}
            dataDetailName="payments"
            dataDetailColumns={paymentColumn}
            dataDetailTitle="A/R Payments"
            onRefreshData={() => {
              getInvoicesData();
            }}
            columns={[
              {
                header: "A/R Invoice ID",
                field: "invoiceCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Invoice Date",
                field: "invoiceDate",
                body: (rowData) => formatDate(rowData.invoiceDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Payment Status",
                field: "paymentStatus",
                body: (rowData) => {
                  if (rowData.paymentStatus === 1) {
                    return (
                      <Badge variant="danger">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.paymentStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.paymentStatus === 3) {
                    return (
                      <Badge variant="success">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.paymentStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Billing Amount",
                field: "billAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.billAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Account Receivable Invoice Detail">
                      <button
                        type="button"
                        onClick={() => {
                          history.push("/finance/invoice-detail/" + rowData.ID);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Account Receivable Invoice PrintOut">
                      <button
                        type="button"
                        onClick={() => {
                          setInvoice(rowData);
                          setOpenInvoicePrint(true);
                        }}
                        className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-print"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            guidance={`You don't have any A/R Invoices for this ${
              docRef === "1"
                ? "sales order"
                : docRef === "5"
                ? "quotation"
                : "document"
            } yet`}
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/finance/invoices/AR");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To A/R Invoice
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openInvoicePrint}
        title="A/R Invoice PrintOut"
        onCloseDialog={() => {
          setOpenInvoicePrint(false);
        }}
        maxWIdth="lg"
      >
        <CustomPrintOutInvoice invoiceID={invoice.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenInvoicePrint(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
};

export default DocRefInvoices;
